// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media(max-width: 900px){

  .hideSmallDevice {
    display: none;
  }
}
@media(min-width: 900px){

  .hideBigDevice {
    display: none;
  }
}

.widthForSmallDevices {
  width: 100%;
  height:50%;
}

.widthForBigDevices {
  width: 50%;
  height:100%;
}
`, "",{"version":3,"sources":["webpack://./src/app/analiza/bar-chart-workers/bar-chart-workers.component.css"],"names":[],"mappings":"AAAA;;EAEE;IACE,aAAa;EACf;AACF;AACA;;EAEE;IACE,aAAa;EACf;AACF;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;AACb","sourcesContent":["@media(max-width: 900px){\n\n  .hideSmallDevice {\n    display: none;\n  }\n}\n@media(min-width: 900px){\n\n  .hideBigDevice {\n    display: none;\n  }\n}\n\n.widthForSmallDevices {\n  width: 100%;\n  height:50%;\n}\n\n.widthForBigDevices {\n  width: 50%;\n  height:100%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
